const dashboard = {
    colors: ['#ed1c24', '#f26522', '#f7941d', '#cdc42a', '#8dc63f', '#39b54a', '#00a651', '#00a99d', '#00aeef', '#0072bc', '#0054a6', '#2e3192', '#662d91', '#92278f', '#ec008c', '#ed145b'],
    createQueryFromFiltros: function(filtros) {
        const sp = new URLSearchParams('');
        sp.append('dataInicial', filtros.dataInicial);
        sp.append('dataFinal', filtros.dataFinal);
        return sp;
    },
    periodoDeMeses: function(dataInicial, dataFinal) {
      if (dataInicial > dataFinal) {
        alert('A data inicial é maior que a data final.');
        return;
      }
      dataInicial = new Date(dataInicial);
      dataFinal = new Date(dataFinal);
      let anoMesFinal = dataFinal.getFullYear() + ('0'+ (dataFinal.getMonth()+1)).slice(-2)
      let range = [];
      for (let i = 0; i < 30; i++) {
        let anoMes = dataInicial.getFullYear() + ('0'+ (dataInicial.getMonth()+1)).slice(-2);
        range.push(anoMes);
        if (anoMes >= anoMesFinal) {
          break;
        }
        dataInicial.setMonth(dataInicial.getMonth()+1);
      }    
      return range;
    },
    titulo: (titulo) => {
      return <h3 className="dashboard-title float-lg-start">{titulo}</h3>
    },
    alert: (texto) => {
      return <div className="alert alert-warning" role="alert" style={{ clear: 'both'}}>{texto}</div>
    },
    alertLoading: () => {
      return dashboard.alert("Carregando gráfico...")
    },
    alertSemDados: () => {
      return dashboard.alert("Não há dados para formar o gráfico com os filtros escolhidos.")
    },
    dropdownCheckeds: (data) => {
      return data.filter(d => d.checked === true);
    },
    calculaLargura: (barraWidth, keys, data, groupMode, margin) => {
      let largura = keys.length * barraWidth;
      if (groupMode === 'stacked') {
        largura = barraWidth
      }
      largura = largura * data.length;
      largura = largura + margin.left + margin.right;
      return largura + 'px';
    },
    ordenaCrescente: (arr, key) => {
      return arr.sort((a, b) => a[key].localeCompare(b[key]))
    },
    converteSegundosParaHoras: (segundos) => {
      return segundos / 3600;
    }
  }
  
  export default dashboard;